import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AgentNavbar from "../../component/AgentNavbar";  
import axios from "axios";
import { baseurl } from "../../component/Baseurl";

function AgentPins() {
  const agentid = localStorage.getItem("agent_id");
  const [transactions, setTransactions] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pinCount, setPinCount] = useState("");
  const [agentPins, setAgentPins] = useState([]);
  const [availablePins, setAvailablePins] = useState(0);

  useEffect(() => {
    if (!agentid) {
      setError("Agent ID not found in local storage.");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        // Fetch wallet transactions
        const walletResponse = await axios.get(`${baseurl}/GetWalletTransactionsForAgent/${agentid}`);
        setTransactions(walletResponse.data.transactions);
        setWalletBalance(walletResponse.data.wallet_balance);

        // Fetch agent pin requests
        const pinsResponse = await axios.get(`${baseurl}AllAgentPins/${agentid}`);
        setAgentPins(pinsResponse.data.data || []);
        setAvailablePins(parseInt(pinsResponse.data.available_pins) || 0);
      } catch (error) {
        setError("Failed to fetch data. Please try again.");
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [agentid]);

  // Function to handle pin request submission
  const handleRequestPins = async (e) => {
    e.preventDefault();
    
    if (!pinCount || pinCount <= 0) {
      alert("Please enter a valid number of pins.");
      return;
    }

    const requestData = { agentid, pinCount };
    console.log("Sending request data:", requestData);

    try {
      const response = await axios.post(`${baseurl}RequestPins`, requestData);
      console.log("Response:", response.data);
      alert(response.data.message);
      setPinCount(""); // Reset input field
    } catch (error) {
      console.error("Request Error:", error);
      alert("Failed to request pins. Please try again.");
    }
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-3 font4"></h1>
          </div>

          {/* Pin Request Form */}
          <div className="card p-3 mb-4">
            <h3 className="title text-start">Request Pins</h3>
            <form onSubmit={handleRequestPins}>
              <div className="row ">
                <div className="col-md-6">
                <div className="mb-3 text-start">
                <label htmlFor="pinCount" className="form-label">Number of Pins:</label>
                <input 
                  type="number" 
                  id="pinCount" 
                  className="form-control" 
                  value={pinCount}  placeholder="Enter Number Of Pins to request"
                  onChange={(e) => setPinCount(e.target.value)}
                  min="1"
                  required
                />
              </div>
                </div>
                <div className="col-md-6 d-flex align-items-center justify-content-end">
                <button type="submit" className="btn btn-primary">Submit Request</button>
                </div>
              </div>
              
              
            </form>
          </div>

          

          {/* Agent Pin Requests Table */}
          <div className="crdmain">
            {/* <h3 className="mt-3 mb-3 text-dark">📌 Agent Pin Requests</h3> */}
            <h3 className="title text-start">📌 Available Pins: {availablePins}</h3>

            {loading ? (
              <p>Loading agent pins...</p>
            ) : agentPins.length === 0 ? (
              <p>No pin requests found.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Pin Quantity</th>
                      <th>Cost per Pin (₹)</th>
                      <th>Total Amount (₹)</th>
                      {/* <th>Status</th> */}
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {agentPins.map((pin, index) => (
                      <tr key={pin.id}>
                        <td>{index + 1}</td>
                        <td>&#8377;{pin.pin_qty}</td>
                        <td>&#8377;{pin.cost_per_pin}</td>
                        <td>&#8377;{pin.total_amount}</td>
                        {/* <td>{pin.status}</td> */}
                        <td>{new Date(pin.created_at).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentPins;
